import { render } from "./Devices.vue?vue&type=template&id=820d1bd8"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"

import "./Devices.vue?vue&type=style&index=0&id=820d1bd8&lang=css"

import exportComponent from "/home/runner/work/web/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__